import { Link } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import RegistrationForm from './components/RegistrationForm';
import SocialRegistration from './components/SocialRegistration';

const UserRegistration = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="flex min-h-screen">
        <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-primary/10 via-accent/5 to-primary/5 p-12 items-center justify-center">
          <div className="max-w-lg">
            <div className="flex items-center gap-3 mb-8">
              <div className="flex items-center justify-center w-14 h-14 bg-primary rounded-xl">
                <Icon name="Briefcase" size={28} color="white" />
              </div>
              <span className="text-3xl font-bold text-foreground">JobPortal India</span>
            </div>

            <h1 className="text-4xl font-bold text-foreground mb-6">
              Start Your Career Journey Today
            </h1>
            
            <p className="text-lg text-muted-foreground mb-8">
              Join thousands of professionals and companies connecting on India's leading job portal platform.
            </p>

            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="flex items-center justify-center w-12 h-12 bg-success/10 rounded-lg flex-shrink-0">
                  <Icon name="CheckCircle2" size={24} color="var(--color-success)" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground mb-1">Access Thousands of Jobs</h3>
                  <p className="text-sm text-muted-foreground">
                    Browse through verified job listings from top companies across India
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex items-center justify-center w-12 h-12 bg-accent/10 rounded-lg flex-shrink-0">
                  <Icon name="Target" size={24} color="var(--color-accent)" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground mb-1">Smart Job Matching</h3>
                  <p className="text-sm text-muted-foreground">
                    Get personalized job recommendations based on your skills and preferences
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-lg flex-shrink-0">
                  <Icon name="TrendingUp" size={24} color="var(--color-primary)" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground mb-1">Career Growth Tools</h3>
                  <p className="text-sm text-muted-foreground">
                    Track applications, build your profile, and advance your career
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-12 p-6 bg-card rounded-xl border border-border">
              <div className="flex items-center gap-4 mb-4">
                <div className="flex -space-x-3">
                  <div className="w-10 h-10 rounded-full bg-primary/20 border-2 border-card flex items-center justify-center">
                    <Icon name="User" size={18} color="var(--color-primary)" />
                  </div>
                  <div className="w-10 h-10 rounded-full bg-accent/20 border-2 border-card flex items-center justify-center">
                    <Icon name="User" size={18} color="var(--color-accent)" />
                  </div>
                  <div className="w-10 h-10 rounded-full bg-success/20 border-2 border-card flex items-center justify-center">
                    <Icon name="User" size={18} color="var(--color-success)" />
                  </div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-foreground">50,000+</div>
                  <div className="text-sm text-muted-foreground">Active Users</div>
                </div>
              </div>
              <p className="text-sm text-muted-foreground">
                Join our growing community of job seekers and employers
              </p>
            </div>
          </div>
        </div>

        <div className="w-full lg:w-1/2 flex items-center justify-center p-6 sm:p-8 lg:p-12">
          <div className="w-full max-w-md">
            <div className="lg:hidden flex items-center justify-center gap-2 mb-8">
              <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
                <Icon name="Briefcase" size={24} color="var(--color-primary)" />
              </div>
              <span className="text-xl font-semibold text-foreground">JobPortal India</span>
            </div>

            <div className="mb-8">
              <h2 className="text-3xl font-bold text-foreground mb-2">Create Account</h2>
              <p className="text-muted-foreground">
                Fill in your details to get started with JobPortal India
              </p>
            </div>

            <RegistrationForm />

            <div className="mt-6">
              <SocialRegistration />
            </div>

            <div className="mt-8 text-center">
              <p className="text-sm text-muted-foreground">
                Already have an account?{' '}
                <Link 
                  to="/user-login" 
                  className="font-medium text-primary hover:underline transition-smooth"
                >
                  Login here
                </Link>
              </p>
            </div>

            <div className="mt-8 pt-6 border-t border-border">
              <div className="flex items-center justify-center gap-6 text-xs text-muted-foreground">
                <a href="#" className="hover:text-foreground transition-smooth">Help Center</a>
                <span>•</span>
                <a href="#" className="hover:text-foreground transition-smooth">Contact Support</a>
                <span>•</span>
                <a href="#" className="hover:text-foreground transition-smooth">FAQs</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserRegistration;